export type LicenseType = 'NONE' | 'SEMI_PERSONALIZED' | 'PERSONALIZED';

export type PaymentDisplayStatus = 'ACTIVE' | 'OVERDUE' | 'UPCOMING' | 'NONE';

export interface StudentPaymentStatus {
  studentId: string;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
  latestPayment: {
    id: string;
    status: string;
    periodEnd: string;
    amount: number;
  } | null;
  nextDueDate: string | null;
  daysUntilDue: number | null;
}

export function licenseLabel(type: LicenseType): string {
  switch (type) {
    case 'SEMI_PERSONALIZED':
      return 'Semi-personalizado';
    case 'PERSONALIZED':
      return 'Personalizado';
    default:
      return 'Sin licencia';
  }
}

export function licenseBadgeClass(type: LicenseType): string {
  switch (type) {
    case 'PERSONALIZED':
      return 'badge-license badge-license-personalized';
    case 'SEMI_PERSONALIZED':
      return 'badge-license badge-license-semi';
    default:
      return 'badge-license badge-license-none';
  }
}

export function paymentDisplayStatus(status: StudentPaymentStatus): PaymentDisplayStatus {
  if (!status.latestPayment) return 'NONE';
  // Próximo vencimiento: activo pero con <= 7 días para vencer
  if (status.isActive && status.daysUntilDue !== null && status.daysUntilDue >= 0 && status.daysUntilDue <= 7) {
    return 'UPCOMING';
  }
  if (status.isActive) return 'ACTIVE';
  // Sin isActive: cuota vencida
  return 'OVERDUE';
}

export function paymentStatusLabel(display: PaymentDisplayStatus): string {
  switch (display) {
    case 'ACTIVE':
      return 'Al día';
    case 'UPCOMING':
      return 'Próximo vencimiento';
    case 'OVERDUE':
      return 'Cuota vencida';
    default:
      return 'Sin pago';
  }
}

export function paymentBadgeClass(display: PaymentDisplayStatus): string {
  switch (display) {
    case 'ACTIVE':
      return 'badge-payment badge-payment-active';
    case 'UPCOMING':
      return 'badge-payment badge-payment-upcoming';
    case 'OVERDUE':
      return 'badge-payment badge-payment-overdue';
    default:
      return 'badge-payment badge-payment-none';
  }
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
